import { render, staticRenderFns } from "./VerificationTrustBadgesPage.vue?vue&type=template&id=4eab5c7d&scoped=true"
import script from "./VerificationTrustBadgesPage.vue?vue&type=script&lang=js"
export * from "./VerificationTrustBadgesPage.vue?vue&type=script&lang=js"
import style0 from "./VerificationTrustBadgesPage.vue?vue&type=style&index=0&id=4eab5c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eab5c7d",
  null
  
)

export default component.exports